<template>
  <div>
    <div id="chattool" v-resize="onResizeTabToollist" class="text-xs-center">
      <v-tabs
        v-if="showChatTool"
        v-model="chattooltype"
        color="grey lighten-3"
        :slider-color="$vuetify.theme.primary"
        :style="{ 'max-width': toolListWidth }"
        show-arrows
      >
        <v-tab ripple :key="'customer'" :href="'#customer'">{{ $t('Info') }}</v-tab>
        <v-tab
          v-if="
            (['ticket', 'ticket2', 'studio7', 'ustore', 'tdtawandang', 'cityfresh'].includes(
              livechatTheme
            ) &&
              !['dentalhub'].includes(selectedBot.type)) ||
            [...$store.state.ticketPageid, ...this.$store.state.toaPaintPage].includes(
              selectedBot.pageid
            ) ||
            ['gpf', 'mtc'].includes(selectedBot.type)
          "
          ripple
          :key="'ticket'"
          :href="'#ticket'"
          >{{ $t('Ticket') }}</v-tab
        >
        <v-tab
          v-if="$store.state.beavermanpage.includes(currentPageid)"
          ripple
          :key="'beavermancontract'"
          :href="'#beavermancontract'"
          >{{ $t('Contact') }}</v-tab
        >
        <v-tab v-if="livechatTheme == 'nvbb'" ripple :key="'quota'" :href="'#quota'">{{
          $t('Quota')
        }}</v-tab>
        <v-tab
          v-if="livechatTheme == 'scgworkplace'"
          ripple
          :key="'workplacecustomer'"
          :href="'#workplacecustomer'"
          >{{ $t('Workplace') }}</v-tab
        >
        <v-tab
          v-if="livechatTheme == 'scgallrent' && allrentcustomer && allrentcustomer.length"
          ripple
          :key="'allrentcustomer'"
          :href="'#allrentcustomer'"
          >{{ $t('Customer') }}</v-tab
        >
        <v-tab
          v-if="$store.state.toacustomerpage.includes(currentPageid)"
          ripple
          :key="'toapaintcustomer'"
          :href="'#toapaintcustomer'"
          >{{ $t('Paint') }}</v-tab
        >
        <v-tab
          v-if="$store.state.toacustomerpage.includes(currentPageid)"
          ripple
          :key="'toapaintercustomer'"
          :href="'#toapaintercustomer'"
          >{{ $t('Painter') }}</v-tab
        >
        <v-tab
          v-if="livechatTheme == 'scgallrent' && allrentsupplier && allrentsupplier.length"
          ripple
          :key="'allrentsupplier'"
          :href="'#allrentsupplier'"
          >{{ $t('Supplier') }}</v-tab
        >
        <v-tab
          v-if="
            $store.state.nestlePages.some((page) => page.pageid == selectedBot.pageid) ||
            ['cityfresh'].includes(livechatTheme)
          "
          ripple
          :key="'ordersummary'"
          :href="'#ordersummary'"
        >
          {{ $t('Order Summary') }}
        </v-tab>
        <v-tab
          v-if="
            $store.state.nestlePages.some((page) => page.pageid == selectedBot.pageid) ||
            ['cityfresh'].includes(livechatTheme)
          "
          ripple
          :key="'currentcart'"
          :href="'#currentcart'"
        >
          {{ $t('Current Cart') }}
        </v-tab>
        <!-- <v-tab ripple :key="'conversation'" :href="'#conversation'">{{$t('Conversation')}}</v-tab> -->
      </v-tabs>
    </div>

    <div
      id
      style="overflow-y: auto"
      v-resize="onResizeToolList"
      :style="{ height: toolListHeight + 'px' }"
    >
      <div v-if="chattooltype == 'ticket'">
        <ticket-list
          v-model="selectedUser.userid"
          :pageid="$store.state.livechat.pageid"
          :key="`ticket_list_${selectedUser.userid}_${selectedUser.type}`"
        ></ticket-list>
      </div>
      <div v-if="chattooltype == 'customer'">
        <livechat-customers
          :theme="livechatTheme"
          :pageid="$store.state.livechat.pageid"
          v-model="selectedUser"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></livechat-customers>
      </div>
      <div v-if="chattooltype == 'workplacecustomer'">
        <scgworkplace-customer
          :pageid="$store.state.livechat.pageid"
          v-model="selectedUser.userid"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></scgworkplace-customer>
      </div>
      <div v-if="chattooltype == 'toapaintcustomer'">
        <ToaPaintCustomer
          :pageid="$store.state.livechat.pageid"
          v-model="selectedUser.userid"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></ToaPaintCustomer>
      </div>
      <div v-if="chattooltype == 'toapaintercustomer'">
        <ToaPainterCustomer
          :pageid="$store.state.livechat.pageid"
          v-model="selectedUser.userid"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></ToaPainterCustomer>
      </div>
      <div v-if="chattooltype == 'allrentcustomer'">
        <ScgAllrentCustomer
          :pageid="$store.state.livechat.pageid"
          v-model="selectedUser"
          :userid="selectedUser.userid"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></ScgAllrentCustomer>
      </div>
      <div v-if="chattooltype == 'quota'">
        <NvbbQuota
          :pageid="$store.state.livechat.pageid"
          v-model="selectedUser"
          :userid="selectedUser.userid"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></NvbbQuota>
      </div>
      <div v-if="chattooltype == 'allrentsupplier'">
        <ScgAllrentSupplier
          :pageid="$store.state.livechat.pageid"
          v-model="selectedUser"
          :userid="selectedUser.userid"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></ScgAllrentSupplier>
      </div>
      <div v-if="chattooltype == 'beavermancontract'">
        <BeavermanContract
          :pageid="$store.state.livechat.pageid"
          v-model="selectedUser"
          :userid="selectedUser.userid"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></BeavermanContract>
      </div>
      <div v-else-if="chattooltype == 'conversation'">
        <div class="pa-1 form-control">
          <input type="text" class="form-control" :placeholder="$t('Search')" />
        </div>
      </div>
      <div v-else-if="chattooltype == 'ordersummary'">
        <livechat-order-summary
          :key="`customer_order_${selectedUser.userid}_${selectedUser.type}`"
        ></livechat-order-summary>
      </div>
      <div v-else-if="chattooltype == 'currentcart'">
        <livechat-currentcart
          :key="`customer_currentcart_${selectedUser.userid}_${selectedUser.type}`"
        ></livechat-currentcart>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ScgworkplaceCustomer from './scgworkplace-customer.vue'
import ScgAllrentCustomer from './scgallrent-customer.vue'
import ScgAllrentSupplier from './scgallrent-supplier.vue'
import NvbbQuota from './NvbbQuota.vue'
import LivechatCustomers from './livechat-customers'
import TicketList from './TicketList'
import ToaPaintCustomer from './ToaPaintCustomer.vue'
import ToaPainterCustomer from './ToaPainterCustomer.vue'
import BeavermanContract from './BeavermanContract.vue'
import LivechatOrderSummary from './livechat-order-summary'
import LivechatCurrentcart from './livechat-currentcart'
import api from '@/api'

export default {
  props: ['selectedUser'],
  components: {
    ScgworkplaceCustomer,
    ScgAllrentCustomer,
    ScgAllrentSupplier,
    NvbbQuota,
    LivechatCustomers,
    TicketList,
    ToaPaintCustomer,
    ToaPainterCustomer,
    BeavermanContract,
    LivechatOrderSummary,
    LivechatCurrentcart
  },
  data() {
    return {
      showChatTool: false,
      chattooltype: 'customer',
      toolListHeight: 0,
      toolListWidth: 'auto',
      allrentcustomer: [],
      allrentsupplier: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    livechatTheme() {
      return this.$store.state.livechat.theme
    },
    currentPageid() {
      return this.$store.state.livechat.pageid
    }
  },
  mounted() {
    var vm = this
    if (this.livechatTheme == 'scgallrent') {
      vm.getallrenttransactionlivechat()
    }
    if (vm.livechatTheme == 'scgworkplace') {
      vm.chattooltype = 'workplacecustomer'
    }
    if (vm.livechatTheme == 'ticket') {
      // vm.chattooltype = 'ticket'
    }
    vm.onResizeToolList()
  },
  methods: {
    getallrenttransactionlivechat() {
      if (this.selectedUser && this.selectedUser.userid) {
        var data = {
          pageid: this.$store.state.livechat.pageid,
          userid: this.selectedUser.userid
        }
        api.getallrenttransactionlivechat(data, (err, response) => {
          if (response.responsecode == 200) {
            this.allrentcustomer = response.data
            this.allrentsupplier = response.data2
          }
        })
      }
    },
    onResizeToolList: function () {
      var vm = this
      vm.$nextTick(function () {
        var toolListHeight = 0
        if (document.getElementById('chattool')) {
          toolListHeight = document.getElementById('chattool').clientHeight
        }
        vm.toolListHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - toolListHeight
      })
    },
    async onResizeTabToollist() {
      this.showChatTool = false
      await this.$nextTick()
      if (document.getElementById('chattool')) {
        this.toolListWidth = `${document.getElementById('chattool').clientWidth - 10}px`
      } else {
        this.toolListWidth = 'auto'
      }

      await this.$nextTick()
      this.showChatTool = true
    }
  },
  watch: {
    selectedUser: function (newVal, oldVal) {
      var vm = this
      if (newVal != oldVal) {
        if (this.livechatTheme == 'scgallrent') {
          vm.getallrenttransactionlivechat()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-chattool.vue